import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import RegistrationForm from "../../components/sentry/RegistrationForm.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import {
  createUser,
  resetUserSignUp
} from "../../state/reducers/signup/signUpActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Register extends PureComponent {
  static propTypes = {
    copy: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.resetUserSignUp();
  }

  // -- HANDLERS -- //

  onReset = () => {
    // used to force render via key on main Container
    this.props.resetUserSignUp();
  };

  onSubmit = values => {
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      emailConfirmation: values.emailConfirmation,
      username: values.username,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation
    };
    this.props.createUser(data);
  };

  // -- RENDER -- //

  render() {
    const { copy } = this.props;

    return (
      <div className="sentry-form">
        <Header as="h3" inverted textAlign="center">
          {copy("sentry.register.title")}
        </Header>
        <ErrorBoundary>
          <RegistrationForm onReset={this.onReset} onSubmit={this.onSubmit} />
          <footer>
            <LinkWithReset to="/">
              {copy("sentry.register.login_cta")}
            </LinkWithReset>
          </footer>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  createUser: data => dispatch(createUser(data)),
  resetUserSignUp: () => dispatch(resetUserSignUp())
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
